import { Button } from '@quest-lock/ui/button'
import NavMenu from './nav-menu'
import { MobileNavDropdown } from './mobile-nav-dropdown'
import { useAuth0 } from '@auth0/auth0-react'
import { useNavigate } from 'react-router-dom'
import { appRoutes } from '@/constants'

const Navbar = () => {
  const { isAuthenticated, loginWithRedirect, logout } = useAuth0()
  const navigate = useNavigate()

  const logoutWithRedirect = () =>
    logout({
      logoutParams: {
        returnTo: window.location.origin
      }
    })

  return (
    <>
      <nav className="bg-background border-shire-dark/20 fixed inset-x-4 top-6 z-50 mx-auto h-20 max-w-screen-xl rounded-full border">
        <div className="mx-auto flex h-full items-center justify-between px-4">
          <div className="flex items-center gap-3">
            <img
              src="/favicon/header-logo.webp"
              className="size-14 cursor-pointer"
              alt="Quest-Lock logo"
              onClick={() => navigate('/')}
            />
            <span className="font-heading text-foreground text-2xl">
              Quest-Lock
            </span>
          </div>
          <NavMenu className="hidden lg:block" />

          <div className="flex items-center gap-3">
            {!isAuthenticated && (
              <>
                <Button
                  variant="outline"
                  className="font-ui hidden rounded-full hover:brightness-90 lg:inline-flex"
                  onClick={() => loginWithRedirect()}
                >
                  Sign In
                </Button>
                <Button
                  className="bg-shire-sun text-shire-dark hover:bg-shire-bark hover:text-shire-light hidden rounded-full lg:inline-flex"
                  onClick={() => navigate(appRoutes.autoLockPlanner)}
                >
                  Get Started
                </Button>
              </>
            )}
            {isAuthenticated && (
              <Button
                variant="outline"
                className="font-ui hidden rounded-full hover:brightness-90 lg:inline-flex"
                onClick={() => logoutWithRedirect()}
              >
                Sign Out
              </Button>
            )}
            <div className="lg:hidden">
              <MobileNavDropdown />
            </div>
          </div>
        </div>
      </nav>
    </>
  )
}

export default Navbar
